<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center py-4">
                    <div class="col-lg-2 col-md-12 col-2 mb-3">
                        <h2>Executed Trades </h2>
                    </div>
                    <div class="col-lg-10 col-md-12 col-10 text-right bid">
                            <div class="input-group d-inline-flex justify-content-end">
                                <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                                    <i @click="search()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                                    <input v-on:keyup.enter="search" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                                    <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">Executed From</label>
                      <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">Executed To</label>
                      <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <label>Ecn</label>
                     <multiselect 
                        v-model="ecn" 
                        placeholder="Select ecn" 
                        :options="['IBP','TWD','TMC']"  
                        :multiple="true" 
                        @input="search"
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3">
                  <label>TRADER</label>
                  <multiselect
                    v-model="filterTrader"
                    placeholder="Select trader"
                    label="firstName"
                    track-by="id"
                    :options="traderList"
                    :multiple="false"
                    :limit="3"
                  ></multiselect>
                </div>
                  <div class="col-md-4 col-lg-3">
                    <div class="form-check mt-4">
                      <input id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="isEmailSent" >
                      <label for="checkbox2" class="form-check-label">Email Sent</label>
                    </div>
                </div>
                  
                  <div class="col-md-6 col-lg-3">
                    <button @click="clear()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="search()" type="button" class="btn btn-primary rounded mt-4">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
            <div class="row xsOnly">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                              <th
                                  scope="col" 
                                  class="sort text-center"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                                  @click="sort('cusip')">Cusip</th>
                                  <th
                                  scope="col" 
                                  class="sort text-left"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusipDescription'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusipDescription'  ? 'sort-desc' : '']"  
                                  @click="sort('cusipDescription')">Description</th>
                                  <th 
                                      scope="col" 
                                      class="sort text-center"
                                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusipCoupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusipCoupon'  ? 'sort-desc' : '']"  
                                      @click="sort('cusipCoupon')">COUPON</th>
                                      <th 
                                      scope="col" 
                                      class="sort text-center"
                                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bondInsurer'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bondInsurer'  ? 'sort-desc' : '']"  
                                      @click="sort('bondInsurer')">BOND INSURER</th>
                                <th 
                                  scope="col" 
                                  class="sort text-center"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'orderQty'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'orderQty'  ? 'sort-desc' : '']"  
                                  @click="sort('orderQty')">EXECUTED QTY</th>  
                              
                                <th 
                                  scope="col" 
                                  class="sort text-center"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidPrice'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidPrice'  ? 'sort-desc' : '']"  
                                  @click="sort('bidPrice')">EXECUTED PRICE</th>
                                  <th 
                                  scope="col" 
                                  class="sort text-center"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ecn'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'ecn'  ? 'sort-desc' : '']"  
                                  @click="sort('ecn')">EXECUTED ECN</th> 
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedYield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedYield'  ? 'sort-desc' : '']"  
                                    @click="sort('executedYield')">EXECUTED YIELD</th>       
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'settleDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'settleDate'  ? 'sort-desc' : '']"  
                                    @click="sort('settleDate')">SETTLEMENT DATE</th>   
                                   
                                     
                                      <th 
                                      scope="col" 
                                      class="sort text-center"
                                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'traderFirstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'traderFirstName'  ? 'sort-desc' : '']"  
                                      @click="sort('traderFirstName')">TRADER</th> 
                                    <th 
                                      scope="col" 
                                      class="sort text-center"
                                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedAt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedAt'  ? 'sort-desc' : '']"  
                                      @click="sort('executedAt')">EXECUTED TIME</th>     
                                      <th 
                                      scope="col" 
                                      class="sort text-center"
                                      >ACTION</th>         
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="bidwantedList.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in bidwantedList" :key="data.id">
                                <td class="text-wrap"><span class="cusips">{{data.cusip}}</span></td>
                                <td>
                                  <span class="desc">{{data.cusipDescription}}</span>
                                </td>
                                <td class="text-center">
                                  {{ data.cusipCoupon |  percent(3)  }}
                                </td>
                                <td class="text-center">
                                  {{ getAbbreviation(data.bondInsurer) }}
                                </td>
                                <td class="text-center">{{data.orderQty}}</td>
                               
                                <td class="text-center">{{data.bidPrice | currency}}</td>
                                <td class="text-center">
                                    {{data.ecn}}
                                </td>
                                <td class="text-center">{{data.executedYield}}</td>
                                <td class="text-center">{{data.settleDate ? moment(data.settleDate).format("MM/DD/YYYY"): 'N/A'}}</td>
                              
                                
                              
                               <td class="text-center">{{data.traderFirstName}} {{data.traderLastName }}</td>

                               <td class="text-center">{{data.executedAt ? data.executedAt : 'N/A'}}</td>

                               <td class="text-center invt">
                                  <div class="d-inline-flex">
                                    <div class="dropdown">
                                        <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                          <button type="button" @click="emailBid(data)" class="dropdown-item" title="Email"><span class="far fa-envelope mr-1"></span> <div>Email ticket</div></button>
                                          <button type="button" @click="downloadBid(data)" class="dropdown-item" title="Download"><span class="fas fa-download mr-1"></span> <div>Download ticket</div></button>
                                          <button type="button" @click="printBid(data)" class="dropdown-item" title="Print"><span class="fas fa-print mr-1"></span> <div>Print ticket</div></button>
                                        </div>
                                    </div>
                                  </div>
                              </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getBidwantedList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "id",
        sortOrder: "DESC",
        bidwantedList : [],
        createdDate : new Date(),
        showFilters : false,
        sendBidWantedModalOpen : false,
        selectedBidWanted : null,
        status :"SUCCESS",
        statusList : ["NEW","BID_SENDING","BID_SENT","ORDER_RECEIVED","ACCEPTED","REJECTED","SUCCESS","HISTORY"],
        ecn : "",
        fromDate : "",
        toDate : "",
        isEmailSent : false,
        filterTrader: null,
        traderList: [],


     
    };
  },
  methods: {
    getTraderList() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader",
          auth
        )
        .then((result) => {
          this.traderList = result.data.content;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    printBid(bid){
        let routeData = this.$router.resolve({
          name: "printticket",
          query: {
            autobidId: bid.id,
            isInventory : bid.isInventory
          }
        });
        window.open(routeData.href, "_blank");
    },
    downloadBid(bid){
        var message = "Are you sure you want to download this trade?";
        this.$confirm(message,"Download","question",{confirmButtonText:"DOWNLOAD",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .get(config.baseUrlAutoBidder + "/autobidder/ticket-download?id="+bid.id,auth)
            .then((response) => {
                this.loading = false;
                //console.log("file",response.data)
                response.data.urls.forEach(file => {
                window.open(file, "_blank");
                })   
            })
            .catch(() => {
                this.loading = false;              
            });
        });

    },
    emailBid(bid){
        var message = null;
        if(bid.isEmailSent){
            message = "Email already sent, are you sure want to send it again?";
        }else{
            message = "Are you sure you want to email this trade?";
        }
        this.$confirm(message,"Email","question",{confirmButtonText:"SEND",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            let data = {
              "id" : bid.id 
            }
            this.$http
            .post(config.baseUrlAutoBidder + "/autobidder/ticket-email",data,auth)
            .then(() => {
                this.loading = false;
                this.$alert("Email sent successfully","","success")              
            })
            .catch(() => {
                this.loading = false;              
            });
        });

    },
    toggleSendBidWantedModal(bid){
      if(bid)
      this.selectedBidWanted = bid;
      this.sendBidWantedModalOpen = !this.sendBidWantedModalOpen;
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getBidwantedList();
    },
    search(){
        this.currentPage = 1;
        this.getBidwantedList();  
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 1;
        this.getBidwantedList();  
    },
    clear(){
        this.searchValue = "";
        this.status = "SUCCESS";
        this.ecn = "";
        this.currentPage = 1;
        this.isEmailSent = false;
        this.filterTrader = null,
        this.getBidwantedList();  
    },
    getBidwantedList(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
        var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            this.status+
            "&sortColumn=" +
            this.sortColumn +
            "&showInvIndicator=true"+
            "&sortOrder=" +
            this.sortOrder+
            "&userId="+
            (this.filterTrader ? this.filterTrader.id : "") +
            "&ecn="+
            this.ecn+
            "&executedFrom="+
            fDate+
            "&executedTo="+
            tDate+
            "&isEmailSent="+
            this.isEmailSent+
            "&loggedUser="+
            authService.getUser().id+
            "&assignedBy=",
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.bidwantedList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    }
   
  },
  mounted() {
    this.fromDate = this.moment().format("MM-DD-YYYY");
    this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
    this.getTraderList();
    this.getBidwantedList();
  }
};
</script>